export enum ReportType {
    CONSOLIDATED_REPORT = 'Reporte Consolidado',
    SIMPLE_REPORT = 'Reporte Simple',
    SPEED_REPORT = 'Reporte de Velocidad',
    STOPPAGE_REPORT = 'Reporte de Paradas',
    TRAVEL_REPORT = 'Reporte de Viajes'
}